// react
import React from "react";
import { connect } from "react-redux";

// analytics library
import Analytics from "../../utils/Analytics";

import PropTypes from "../../lib/prop-types";

class AnalyticsElement extends React.Component {
	static propTypes = {
		userId: PropTypes.string.isRequired,
		companyId: PropTypes.string.isRequired,
		companyName: PropTypes.string.isRequired,
	};

	componentDidMount() {
		Analytics.init({
			userId: this.props.userId,
			companyId: this.props.companyId,
			companyName: this.props.companyName,
		});
	}

	render() {
		return <div />;
	}
}

const mapStateToProps = (state) => ({
	userId: state.app.getIn(["user", "id"]),
	companyId: state.app.getIn(["user", "company", "id"]),
	companyName: state.app.getIn(["user", "company", "name"]),
});

export default connect(mapStateToProps)(AnalyticsElement);
